import { memo, type ReactNode } from 'react';
import { panelLead, panelTitle } from './panelHeader.styles.js';

export interface SettingsTabPanelHeaderProps {
  readonly eyebrow: string;
  readonly title: string;
  readonly lead?: string;
  /** Optional control beside the title (e.g. MetricExplainButton). */
  readonly titleEnd?: ReactNode;
  readonly className?: string;
}

export const SettingsTabPanelHeader = memo(
  ({
    eyebrow,
    title,
    lead,
    titleEnd,
    className = '',
  }: SettingsTabPanelHeaderProps): JSX.Element => {
    const rootClass = ['sic-panel-head', className].filter((part) => part.length > 0).join(' ');

    return (
      <header className={rootClass} data-testid="settings-tab-panel-header">
        <p className="text-xs font-semibold uppercase tracking-wide text-[var(--color-an-primary)]">
          {eyebrow}
        </p>
        <h2 className={panelTitle()}>
          <span className="inline-flex min-w-0 flex-wrap items-center gap-1.5">
            <span>{title}</span>
            {titleEnd != null ? titleEnd : null}
          </span>
        </h2>
        {lead != null && lead !== '' ? <p className={panelLead()}>{lead}</p> : null}
      </header>
    );
  },
);

SettingsTabPanelHeader.displayName = 'SettingsTabPanelHeader';
